import { render, staticRenderFns } from "./banned.vue?vue&type=template&id=12af6576&scoped=true"
import script from "./banned.vue?vue&type=script&lang=js"
export * from "./banned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12af6576",
  null
  
)

export default component.exports